import { type JSX } from 'react'

import { SelectListbox, type SelectListboxProps } from 'base-ui'

import { ProductSearchRefinementCategoryListboxBody } from './ProductSearchRefinementCategoryListboxBody'

export const ProductSearchRefinementCategoryListbox = <
  OptionValue extends NonNullable<unknown>,
  Multiple extends boolean,
>(
  props: SelectListboxProps<OptionValue, Multiple>,
): JSX.Element => (
  <SelectListbox
    {...props}
    slots={{ body: ProductSearchRefinementCategoryListboxBody }}
  />
)
